import APIStage from '@api/graphqlStageOld';
import { Select } from '@ui';
import { observer } from 'mobx-react';
import type { FC } from 'react';
import { useEffect, useState } from 'react';
import { useHistory } from '@compat/router';
import { autorun } from 'mobx';
import { useStores } from '@root/src/stores';
import './index.scss';

interface TransferToOrderProps {
  type: 'cartPage' | 'miniCart';
}

const TransferToOrder: FC<TransferToOrderProps> = observer(({ type }) => {
  const { cartStore, userStore } = useStores();
  const { ordersThatUserCanChange } = userStore;
  const [selectedOrderId, setSelectedOrderId] = useState<number>();
  const history = useHistory();

  useEffect(() => {
    const disposer = autorun(() => {
      if (userStore.ordersThatUserCanChange) {
        setSelectedOrderId(userStore?.ordersThatUserCanChange?.[0]);
      }
    });
    return () => {
      disposer();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const selectValue = (_, value): void => {
    setSelectedOrderId(value);
  };

  const submitMergeCarts = (): void => {
    if (!selectedOrderId) {
      return;
    }
    APIStage.createCartFromOrder({ orderId: selectedOrderId })
      .then(async res => {
        if (!res.createCartFromOrder.cart) {
          return await Promise.reject(new Error('Произошла ошибка'));
        }
        return res.createCartFromOrder.cart.cookieId;
      })
      .then(token => {
        if (token) {
          cartStore.mergeCarts({ targetCartToken: token, sourceCartToken: '' });
        }
      })
      .then(() => {
        const pathname = `/cabinet/orders/${selectedOrderId}`;
        if (history.location.pathname === pathname) {
          location.reload();
        } else {
          history.push(`/cabinet/orders/${selectedOrderId}`);
        }
      });
  };
  if (
    cartStore.cartType === 'bar-menu' ||
    ordersThatUserCanChange?.length === 0 ||
    cartStore.isCartEmpty
  ) {
    return null;
  }
  return (
    <div
      className={`transfer-to-order${
        type === 'miniCart' ? ' transfer-to-order--mini-cart' : ''
      }`}
    >
      <div className='transfer-to-order__title'>
        Добавить товары в активный заказ?
      </div>
      <div className='transfer-to-order__select-wrapper'>
        <Select
          classNameSelect='transfer-to-order__select'
          list={ordersThatUserCanChange?.map(item => ({
            value: item,
            label: `#${item}`
          }))}
          activeValue={selectedOrderId}
          callback={selectValue}
          field='quantity'
        />
        <button
          className='transfer-to-order__submit-btn'
          onClick={submitMergeCarts}
        >
          Да
        </button>
      </div>
    </div>
  );
});

export default TransferToOrder;
